import { styled } from '@mui/material/styles';
import { TableCell, tableCellClasses, TableRow } from '@mui/material';
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&.Mui-selected': {
        backgroundColor: 'rgba(0, 143, 197, 0.6) !important',
    },
    '&:nth-of-type(even)': {
        backgroundColor: 'rgba(0, 143, 197, 0.1)',
    },
    '&:hover': {
        backgroundColor: 'rgba(0, 143, 197, 0.3) !important',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    td: {
        padding: '4px 16px',
    },
}));
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgb(237, 237, 237)',
        padding: 2,
        height: 40,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
